import React, { Dispatch, useEffect, useState } from "react";
import ModalWrapper from "../../../../../components/ModalWrapper";
import RlCloudSandboxScreenshots from "./RlCloudSandboxScreenshots";
import Icon from "../../../../../components/Icon";
import RlCloudSandboxAnalysisDropdown from "./RlCloudSandboxAnalysisDropdown";
import Typography from "../../../../../components/typography/Typography";
import { HistoryAnalysis } from "../../../../samples_cloud/@types";

type ModalProps = {
  hash: string;
  historyAnalysis: HistoryAnalysis[];
  showModal: boolean;
  onHide: () => void;
  isNetwork?: boolean;
};

type TitleProps = {
  historyAnalysis: HistoryAnalysis[];
  activeAnalysisId: string;
  setActiveAnalysisId: Dispatch<string>;
};

const RLCSScreenshotsTitle: React.FC<TitleProps> = ({
  historyAnalysis,
  activeAnalysisId,
  setActiveAnalysisId
}) => (
  <div style={{ display: "inline-flex", alignItems: "center" }}>
    <Typography variant="h4" tag="span">
      Cloud Sandbox Analysis Screenshots
    </Typography>
    <div className="vertical-divider"></div>
    <RlCloudSandboxAnalysisDropdown
      historyAnalysis={historyAnalysis}
      activeAnalysisId={activeAnalysisId}
      setActiveAnalysisId={setActiveAnalysisId}
    />
  </div>
);

const RlCloudSandoxScreenshotsModal: React.FC<ModalProps> = ({
  historyAnalysis,
  hash,
  showModal,
  onHide,
  isNetwork = false
}) => {
  const [activeAnalysisId, setActiveAnalysisId] = useState(
    historyAnalysis?.[0]?.analysis_id
  );
  useEffect(() => {
    if (!activeAnalysisId) {
      setActiveAnalysisId(historyAnalysis?.[0]?.analysis_id);
    }
  }, [activeAnalysisId, historyAnalysis]);
  return (
    <ModalWrapper
      show={showModal}
      titleIcon={<Icon name="rl-logo-square" />}
      title={
        <RLCSScreenshotsTitle
          historyAnalysis={historyAnalysis}
          activeAnalysisId={activeAnalysisId}
          setActiveAnalysisId={setActiveAnalysisId}
        />
      }
      size="lg"
      onHide={onHide}
      centered
      data-testid="rlcs_screenshots_modal"
    >
      <RlCloudSandboxScreenshots
        hash={hash}
        isNetwork={isNetwork}
        activeAnalysisId={activeAnalysisId}
        loadingIndicator
      />
    </ModalWrapper>
  );
};

export default RlCloudSandoxScreenshotsModal;
